import { PrioritizedQueueWOTable } from "./PrioritizedQueueWOTable";

export default PrioritizedQueueWOTable;
